import {
  MDBCol,
  MDBContainer,
  MDBFooter,
  MDBIcon,
  MDBRow
} from 'mdb-react-ui-kit';
import React, { useContext, useEffect } from 'react';
import { Link, } from 'react-router-dom';
import { MiscContext } from './context/MiscProvider';
import { NavbarContext } from './context/NavProvider';
import { UserProfileContext } from './context/UserProfileProvider';
import LoginModal from './login/LoginModal';
function FooterDynamic() {
  const { tokenLoaded} = useContext(UserProfileContext);
  const {pageData} = useContext(NavbarContext);
  const {setBasicOpen, containerRef} =useContext(MiscContext);



  useEffect(() => {
    if (containerRef.current) {
      const script1 = document.createElement('script');
      script1.type = 'text/javascript';
      script1.text = 'var ANS_customer_id="c1c47fcb-5cab-452f-8919-7e3a57619ef4";';
      containerRef.current.appendChild(script1);

      const script2 = document.createElement('script');
      script2.type = 'text/javascript';
      script2.src = "//verify.authorize.net:443/anetseal/seal.js";
      containerRef.current.appendChild(script2);
    }
  }, []);

  
  return (

    <section className="mb-2 position-relative grainy-gradient-intro justify-content-center text-center" ref={containerRef}>
      <MDBFooter bgColor='light' className='text-center text-lg-start  mt-1 text-success rounded' >
        <section className='d-flex justify-content-center justify-content-lg-between p-4 border-bottom'>
          <div className='me-5 d-none d-lg-block'>
            <span>Get connected with us on social networks:</span>
          </div>

          <div>

            <a href='/home' className='me-4 text-reset'>
              <MDBIcon color='secondary' fab icon='youtube' />
            </a>
            <a href='/home' className='me-4 text-reset'>
              <MDBIcon color='secondary' fab icon='facebook-f' />
            </a>
            <a href='/home' className='me-4 text-reset'>
              <MDBIcon color='secondary' fab icon='twitter' />
            </a>
            <a href='home' className='me-4 text-reset'>
              <MDBIcon color='secondary' fab icon='google' />
            </a>
            <a href='home' className='me-4 text-reset'>
              <MDBIcon color='secondary' fab icon='instagram' />
            </a>
            <a href='/home' className='me-4 text-reset'>
              <MDBIcon color='secondary' fab icon='linkedin' />
            </a>

          </div>
        </section>
      

        <section className=''>
          
          <MDBContainer className='text-center text-md-start mt-5'>            
          <div style={{
    position: 'absolute',
    bottom: '1px',
    right: '2px',
    fontSize: '0.8rem',
  
    backgroundColor: 'rgba(0, 0, 0, 0.05)' ,
   
    borderRadius: '5px',
   
  }}>
    1.0.0
  </div>
          <MDBRow className='mt-3'>            
              {
               pageData?.footerBlocks?.map((footerBlock, index) => {
                  return (                    
                   index === 0 &&  <MDBRow   className='mx-auto mb-4' key={index}>
                      <h6 className='text-capitalize fw-bold mb-4 d-flex align-items-center'>
                        {
                          (footerBlock.heading.imageUrl !== undefined && footerBlock.heading.imageUrl !== null) && (
                            <img src={footerBlock.heading.imageUrl} alt="Logo" style={{ height: '70.5px', marginRight: "15px" }} />
                          )
                        }                      
                        <p className=" mb-0 ml-2 text-black">{footerBlock.heading.textValue}</p>
                      </h6>
                      {
                        footerBlock.content.map((footerContent, index) => {
                          return (
                          <p key={index} className='text-primary'> 
                            {
                              (footerContent.icon !== undefined && footerContent.icon !== null) && (
                                <MDBIcon color='secondary' icon={footerContent.icon} className='me-2' />
                              )
                            }
                             <span className='text-primary text-start' dangerouslySetInnerHTML={{ __html: footerContent.textValue }} />
                </p>
                          )
                        })
                      }
                      
                    </MDBRow>
                  )
                  
                })
              }
            </MDBRow>
            <MDBRow className='mt-3'>            
              {
                pageData?.footerBlocks?.map((footerBlock, index) => {
                  return (                    
                    <MDBCol md='3' lg='4' xl='3' className='mx-auto mb-4' key={index}>
                    <h6 className='text-capitalize fw-bold mb-4'>{footerBlock?.heading?.textValue}</h6>
                      { index !==0 &&
                        footerBlock.content.map((footerContent, index) => {
                          return (
                          <p key={index}>
                            {
                              (footerContent.icon !== undefined && footerContent.icon !== null) && (
                                <MDBIcon color='secondary' icon={footerContent.icon} className='me-2' />
                              )
                            }
                            <Link to={footerContent?.link} className='nav-link me-4'>
                 <span className='text-primary' dangerouslySetInnerHTML={{ __html: footerContent.textValue }} />
            </Link>

                           
                </p>
                          )
                        })
                      }
                      
                    </MDBCol>
                  )
                })
              }
            </MDBRow>
          </MDBContainer>
          
        </section>
     

        {!tokenLoaded && <section className='p-4 text-center text-black rounded' style={{ backgroundColor: '#dd4b39' }}>
          <p className='d-flex justify-content-center align-items-center'>
            <span className='me-3'>Register for free</span>
            <LoginModal
              setBasicOpen={setBasicOpen}

            />
          </p>
        </section>}


        <div className='text-center p-4' style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)' }}>
          © 2023 Copyright:
          <a className='text-reset fw-bold' href={`https://${pageData?.domainUrl}`}>
            {pageData?.domainUrl}
          </a>
        </div>
      </MDBFooter>
    </section>
  )
}


export default FooterDynamic;